import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { ModuleDataHandler } from '../../helpers/handleReportCalc';

const style1 = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '60.4px',
  width: '100p%',
  border: '3px solid #d0ebff',
};
interface IProps {
  moduleData: any;
  isView: boolean;
  item: any;
  index: number;
}
const TBodyRow = ({ moduleData, isView, item, index }: IProps) => {
  const [render, setRender] = useState(false);
  const dataHandler = new ModuleDataHandler(moduleData);

  return (
    <>
      <tr>
        <td>
          {item?.customer_name ||
            (typeof item?.part_id !== 'string' &&
              item?.part_id?.customer_id.customer_name)}
        </td>

        <td>
          {item?.part_name ||
            (typeof item?.part_id !== 'string' && item?.part_id?.part_name)}
        </td>
        <td>
          {item?.part_number ||
            (typeof item?.part_id !== 'string' && item?.part_id?.part_number)}
        </td>
        <td>{item?.sale_rate}</td>

        <td style={{ width: '120px' }}>
          <TableInput
            isView={isView}
            name="sale_plan"
            type="number"
            value={item.sale_plan}
            onChange={(e) => {
              item.sale_plan = Number(e.target.value);
              dataHandler.handelSaleplanamountAndBalance(index);
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>{item.sale_plan_amount}</td>
        <td style={{ maxWidth: '100px' }}>
          <span style={style1}>{item.total_dispatch}</span>
        </td>
        <td style={{ maxWidth: '100px' }}>
          <span style={style1}>{item.sale_amount}</span>
        </td>
        <td>{item.balance}</td>
      </tr>
    </>
  );
};

export default TBodyRow;
